/* eslint-disable perfectionist/sort-objects */

const tenants = '/organizations';
const users = '/users';
const usersLogs = '/users-logs';
const profileForm = '/profile-form';
const courses = '/courses';
const projects = '/projects';
const steps = '/steps';
const reports = '/reports';
const children = '/children';
const library = '/library';
const libraryTenant = `${library}/:tenantId`;
const libraryResources = `${libraryTenant}/resources`;
const libraryTags = `${libraryTenant}/tags`;
const libraryResourcesPlaceholder = `${library}/resources`;
const libraryTagsPlaceholder = `${library}/tags`;
const messageOrgAdmins = '/message-org-admins';
const pdfManagement = '/pdf-management';

const Auth = {
  Login: '/login',
  SsoCallback: '/sso/callback',
  SsoIdpStartLogin: '/sso/idp/start-login',
  Verify: '/verify',
  SelectVerify: '/select-verify',
  ForgotPassword: '/forgot-password',
};

const Profile = {
  Home: '/profile',
};

const Tenant = {
  Home: tenants,
  Details: `${tenants}/:id`,
  New: `${tenants}/new`,
  Edit: `${tenants}/edit/:id`,
};

const userDetails = `${users}/:id`;

const User = {
  Home: users,
  Details: userDetails,
  New: `${users}/new`,
  Edit: `${users}/edit/:id`,
  Children: {
    Home: `${userDetails}${children}`,
    Details: `${userDetails}${children}/:childId`,
    Edit: `${userDetails}${children}/:childId/edit`,
  },
};

const UsersLogs = {
  Home: usersLogs,
};

const ProfileForms = {
  Home: profileForm,
  Details: `${profileForm}/:id`,
  New: `${profileForm}/new`,
  Edit: `${profileForm}/edit/:id`,
};

const courseEdit = `${courses}/edit/:id`;

const Courses = {
  Home: courses,
  Details: `${courses}/:id`,
  New: `${courses}/new`,
  Edit: courseEdit,
  Steps: {
    Home: `${courseEdit}${steps}`,
    Details: `${courseEdit}${steps}/:stepId`,
    New: `${courseEdit}${steps}/new`,
    Edit: `${courseEdit}${steps}/edit/:stepId`,
  },
};

const Project = {
  Home: projects,
  Details: `${projects}/:id`,
  New: `${projects}/new`,
  Edit: `${projects}/:id/edit`,
};

const Reports = {
  Home: reports,
  GameAnalytics: `${reports}/game-analytics`,
};

const Library = {
  Home: library,
  Resources: {
    Placeholder: libraryResourcesPlaceholder,
    Home: libraryResources,
    Details: `${libraryResources}/:id`,
    New: `${libraryResources}/new`,
    Edit: `${libraryResources}/:id/edit`,
  },
  Tags: {
    Placeholder: libraryTagsPlaceholder,
    Home: libraryTags,
    Details: `${libraryTags}/:id`,
    New: `${libraryTags}/new`,
    Edit: `${libraryTags}/:id/edit`,
  },
};

const MessageOrgAdmins = {
  Home: messageOrgAdmins,
};

const PdfManagement = {
  Home: pdfManagement,
};

/* eslint-enable perfectionist/sort-objects */

export const AppRoutes = {
  Auth,
  User,
  Tenant,
  Project,
  Courses,
  Profile,
  Reports,
  Library,
  UsersLogs,
  Home: '/',
  ProfileForms,
  PdfManagement,
  MessageOrgAdmins,
  NotFound: '/not-found',
};
